import { postHostedOnboardingOptions, postHostedUserTokensOptions } from '@onefootprint/fetch-hosted';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { retryOnConnectionError } from '@/idv2/components/errors/get-error-key';
import { setIdv2StoreData } from '@/idv2/features/idv-to-idv2';
import { getLogger } from '@/idv2/utils/logger';

const { logError, logInfo } = getLogger({ name: 'idv2', location: 'wait-for-components-sdk' });

export const Route = createFileRoute('/wait-for-components-sdk/$token')({
  beforeLoad: async ({
    context: { componentsSdkRelay, queryClient, overallOutcome, fixtureRiskSignals },
    params: { token },
  }) => {
    if (!componentsSdkRelay) {
      logError('Reached wait-for-components-sdk without componentsSdkRelay');
      throw redirect({ to: '/onboarding/$token', params: { token } });
    }

    const headers = { 'X-Fp-Authorization': token };

    // Initialize onboarding session before relaying — footprint-react calls proceed
    // immediately after receiving the relay, which requires an active workflow.
    // Whichever call fetches first sets the gcTime, so match the onboarding route's.
    await queryClient.ensureQueryData({
      ...postHostedOnboardingOptions({
        headers,
        body: { fixtureResult: overallOutcome, fixtureRiskSignals },
      }),
      gcTime: Infinity,
      retry: retryOnConnectionError,
    });

    const { token: vaultingToken } = await queryClient.fetchQuery({
      ...postHostedUserTokensOptions({
        headers,
        body: { requestedScope: 'onboarding_components' },
      }),
      retry: retryOnConnectionError,
    });

    logInfo('Scoped token created, relaying to components SDK');
    componentsSdkRelay.relayToComponents({ authToken: token, vaultingToken });

    await new Promise<void>(resolve => {
      componentsSdkRelay.onRelayFromComponents(resolve);
    });

    logInfo('relayFromComponents received, resuming onboarding');
    setIdv2StoreData({ componentsSdkRelayCompleted: true });
    throw redirect({ to: '/onboarding/$token', params: { token } });
  },
});
